import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  MotifButton,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
  MotifErrorMessage,
} from '@ey-xd/motif-react'
import './global-errors.scss'
import { resetError, setErrorUI } from './errors-slice'
import { useLocation, useNavigate } from 'react-router-dom'

const ERROR_CONFIG: Record<
  number,
  { heading: string; message: string; autoLogout?: boolean }
> = {
  401: {
    heading: 'Session Expired',
    message: 'Your session has expired. Please log in again.',
    autoLogout: true,
  },
  400: {
    heading: 'Bad Request',
    message: 'There was an error with your request. Please try again.',
  },
  404: {
    heading: 'Resource Not Found',
    message: 'The requested resource was not found. Please try again.',
  },
  500: {
    heading: 'Error',
    message: 'An unexpected error occurred. Please try again later.',
  },
  502: {
    heading: 'Error',
    message: 'An unexpected error occurred. Please try again later.',
  },
}

export default function GlobalErrorPopup() {
  const errors = useSelector((state: any) => state.errors)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    for (const code of Object.keys(ERROR_CONFIG).map(Number)) {
      if (code === 400) {
        const hasOtherErrors = errors[code].some(
          (error: any) => !error.name.includes('saveClient')
        )
        if (!hasOtherErrors) {
          continue
        }
      }
      if (code === 404) {
        const hasOtherErrors = errors[code].some(
          (error: any) => !error.name.includes('usersList') && !error.name.includes('getDevOps')
        )
        if (!hasOtherErrors) {
          continue
        }
      }
      if (errors[code]?.length > 0) {
        const { heading, message, autoLogout } = ERROR_CONFIG[code]
        if (!errors.isDisableGlobalErrorPopup)   {
          dispatch(setErrorUI({ show: true, heading, message }))
        }
        if (autoLogout) {
          setTimeout(() => {
            dispatch(resetError())
            navigate('/logout')
          }, 3000)
        }
        break
      }
    }
  }, [errors, dispatch, navigate])

  if (location.pathname === '/logout') return null

  return (
    <MotifModal
      onClose={() => dispatch(resetError())}
      show={errors.ui.show}
      focusTrapOptions={{
        tabbableOptions: { displayCheck: 'none' },
      }}
      className="global-error-modal"
    >
      <MotifModalHeader className="error-modal-header">
        {errors.ui.heading || 'Error'}
      </MotifModalHeader>
      <MotifModalBody>
        <MotifErrorMessage>
          {errors.ui.message || 'error message'}
        </MotifErrorMessage>
        {errors[401]?.length > 0 && <MotifProgressLoader />}
      </MotifModalBody>
      <MotifModalFooter>
        <div className="motif-row justify-content-end gap-1">
          <MotifButton
            onClick={() => dispatch(resetError())}
            size="small"
            type="button"
            variant="primary"
          >
            OK
          </MotifButton>
        </div>
      </MotifModalFooter>
    </MotifModal>
  )
}
